export enum PathToLiveEnvironment {
  PREPROD = 'PREPROD',
  LIVE = 'LIVE'
}

export const pathToLiveEnvironments = Object.values<PathToLiveEnvironment>(PathToLiveEnvironment);
